export const IllnessIcon = () => {
  return (
    <svg width="17" height="11" viewBox="0 0 17 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.25 0.629992C16.2513 0.468381 16.1903 0.306367 16.0669 0.183058C15.9436 0.0597575 15.7816 -0.00125537 15.62 1.95723e-05C15.6184 6.5321e-06 15.6167 0 15.615 0H11.625C11.2798 0 11 0.279822 11 0.625C11 0.970178 11.2798 1.25 11.625 1.25H14.1161L9.125 6.24112L6.9205 4.03661C6.48115 3.59727 5.76884 3.59727 5.3295 4.03661L0.183058 9.18306C-0.0610194 9.42714 -0.0610194 9.82286 0.183058 10.0669C0.427136 10.311 0.822864 10.311 1.06694 10.0669L6.125 5.00888L8.3295 7.21339C8.76884 7.65273 9.48116 7.65273 9.9205 7.21339L15 2.13388V4.625C15 4.97018 15.2798 5.25 15.625 5.25C15.9702 5.25 16.25 4.97018 16.25 4.625V0.635C16.25 0.633329 16.25 0.63166 16.25 0.629992Z"
        fill="#969BAA"
      />
    </svg>
  );
};
